/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'faqs',
};
